import React from 'react';
import { useSelector } from 'react-redux';

import { LoginButton } from 'features/order-tracker/shared-components';
import { SimpleCloseIcon } from 'features/order-tracker/shared-components/svg';
import { getIsAmendAppointmentEnabled } from 'features/order-tracker/store/selectors';

import { AA_DISABLED_BANNER_MESSAGE, AA_ENABLED_BANNER_MESSAGE } from './constants';

import styles from './styles.module.scss';

export const Banner: React.FC<components.Banner> = ({ isShowBanner, handleHideBanner }) => {
  if (!isShowBanner) return null;

  const isAmendAppointmentEnabled = useSelector(getIsAmendAppointmentEnabled);

  const message = isAmendAppointmentEnabled ? (
    <>
      <p>{AA_ENABLED_BANNER_MESSAGE[0]}</p>
      <p>{AA_ENABLED_BANNER_MESSAGE[1]}</p>
    </>
  ) : (
    <p>{AA_DISABLED_BANNER_MESSAGE}</p>
  );

  return (
    <div className={styles.bannerContainer}>
      <div className={styles.poster} />
      <button data-testid="closeIcon" type="button" className={styles.closeButton} onClick={handleHideBanner}>
        <SimpleCloseIcon color="white" height={10} width={10} />
      </button>
      <div className={styles.bannerText}>
        <h3>There’s so much more...</h3>
        {message}
      </div>
      <LoginButton target="_self" className={styles.loginButton} />
    </div>
  );
};
